<template>
  <div class="container">
    <arrorImg bg="white"></arrorImg>
    <navBar title="搜索" color="#ffffff"></navBar>
    <div class="search-title">
      <div>
        <div>
          <img src="../../../static/bookCity_search.png" alt="" />
          <input
            ref="seach_input"
            class="uni-input"
            v-myfocus="true"
            v-model="keyword"
            placeholder="搜索书名和作者名"
            @input="getKeyword"
          />
        </div>
        <img
          class="close-image"
          v-if="keyword"
          @click="closeSearch"
          src="../../../static/search_close.png"
          alt=""
        />
      </div>
      <span :class="{ active: keyword.length > 0 }" @click="searchData"
        >搜索</span
      >
    </div>
    <div class="content-search">
      <div
        class="search-history"
        v-if="(!isResult || isEmpty) && historyList.length > 0"
      >
        <div class="history-title">
          <span>历史记录</span>
          <span @click="deleteHistory">清空</span>
        </div>
        <div class="history-list">
          <p v-for="(item, index) in historyList" :key="index">
            <!-- display: flex; flex-flow: wrap  -->
            <!-- 43.5%    :style="{'float':index%4==3?'right':'',marginLeft:index%4==0?'initial':'12.5%'}"-->
            <!--   :style="{marginLeft:index%4==0?'initial':'3%'}" -->
            <span @click="chooseData(item)">{{ item }}</span>
          </p>
        </div>
      </div>
      <!-- 热门搜索列表 -->
      <div class="search-hot" v-if="!isResult">
        <span>热门搜索</span>
        <div class="hot-list">
          <div
            class="hot-listitem"
            v-for="(item, index) in hotList"
            :key="index"
            @click="routeDetail(item)"
          >
            <span class="hot-num">{{ index + 1 }}</span>
            <uniListItem :itemChild="item"></uniListItem>
            <!-- <span class="hot-name">{{ item }}</span> -->
          </div>
        </div>
      </div>
      <!-- 搜索结果 -->
      <div class="search-list" v-if="isResult">
        <div v-if="searchList.length > 0">
          <ul
            v-infinite-scroll="loadMore"
            :infinite-scroll-disabled="loading"
            infinite-scroll-distance="10"
          >
            <li
              v-for="(itemChild, index) in searchList"
              :key="index"
              @click="routeDetail(itemChild)"
            >
              <uniListItem :itemChild="itemChild"></uniListItem>
            </li>
          </ul>
          <div class="load-more">
            <span>{{ loadingText }}</span>
          </div>
        </div>
        <div class="no-result" v-if="isEmpty">
          <img src="../../../static/no-result.png" alt="" />
          <span>无搜索结果，换个关键词试试吧~</span>
        </div>
      </div>
      <!-- 历史记录 -->
    </div>
  </div>
</template>
<script>
import { Toast, MessageBox } from "mint-ui";
import uniListItem from "../components/list-item.vue";
import arrorImg from "../../components/arrow-img.vue";

import navBar from "../components/navbar.vue";
export default {
  name: "booSearch",
  components: {
    uniListItem,
    arrorImg,
    navBar,
  },
  data() {
    return {
      isEmpty: false,
      loading: false,
      hotList: [], //热门搜索列表
      historyList: [], //历史列表
      searchList: [],
      keyword: "",
      pageNo: 1,
      isResult: false, //搜索结果
      loadingText: "没有更多了",
      pageCount: 1,
      remark: "",
      isEntranceData: "",
      pageType:''
    };
  },
  mounted() {
    console.log(this.$route);
    if (this.$route.query.keyword) {
      this.keyword = this.$route.query.keyword;
    }
   
    if (this.$route.query.isEntranceData) {
      this.isEntranceData = this.$route.query.isEntranceData;
    }
    
    this.pageType= this.$route.query.pageType;
    this.historyList = this.$base.getStorage("keyword")
      ? JSON.parse(this.$base.getStorage("keyword"))
      : [];
    var openid = this.$base.getStorage("openid");
    var isWxAuthorized = this.$base.getStorage("isWxAuthorized");
    var city = this.$base.getStorage("city");
    if (!openid) {
      //静默登录手动登录
    } else if (
      isWxAuthorized == 0 &&
      city == 1 &&
      openid &&
      !this.$store.state.user.isSNS
    ) {
      this.$base.setStorage("isSNS", true);
      this.$store.state.user.isSNS = true;
      this.$commonApi.snsapiUserinfo();
      if (this.keyword) {
        this.searchData();
      }
      this.getHotSearchBookInfo();
    } else {
      if (this.keyword) {
        this.searchData();
      }
      this.getHotSearchBookInfo();
    }
    this.$commonApi.share();
  },
  beforeRouteLeave(to, from, next) {
    if (from.name == "bookSearch" && to.name == "bookDetail") {
      from.meta.isBack = true;
      from.meta.keepAlive = true;
      var arr = this.$store.state.user.catch_components;
      if (arr.indexOf("bookSearch") < 0) {
        arr.push("bookSearch");
      }
      this.$store.commit("GET_CATCHE_COMPONENTS", arr);
    } else {
      from.meta.isBack = false;
      from.meta.keepAlive = false;
    }
   
    next();
  },
  methods: {
    loadMore() {
      this.loading = true;
      if (this.pageCount > this.pageNo) {
        this.pageNo += 1;
        this.getSearchBook();
      } else {
        this.loading = false;
        this.loadingText = "没有更多了";
      }
    },
    insertPageAccessData() {
      var pageType = "";
      if (this.pageType == "bookMine") {
        pageType = "我的";
      } else if (this.pageType == "bookRead") {
        pageType = "阅读器";
      } else if (this.pageType == "bookTask") {
        pageType = "任务中心";
      }else if (this.pageType === "bookCity") {
        pageType = "书城";
      } else if (this.pageType === "bookRecharge") {
        pageType = "充值中心";
      }
      var params = {
        pageName: "搜索页",
        pageRemark: '上级页面：'+pageType+";关键字：" + this.keyword,
        isEntranceData: this.isEntranceData,
      };
      this.$api.insertPageAccessData(params).then((res) => {});
    },
 
    getHotSearchBookInfo() {
      var params = {
        pageNo: 1,
        pageSize: 10,
      };
      this.$api.getHotSearchBookInfo(params).then((res) => {
        if (res.status == 1) {
          res.data.forEach((item) => {
            var num = (item.studyingVolume / 10000).toFixed(2);
            if (num >= 999.99) {
              item.studyingVolume = 999.99;
            } else {
              item.studyingVolume = num;
            }
          });
          this.hotList = res.data;
          this.insertPageAccessData();
        
        }
      });
    },
    getSearchBook() {
      var searchParams = {
        pageNo: this.pageNo,
        pageSize: 10,
        search: this.keyword,
      };
      this.$api.getSearchBook(searchParams).then((res) => {
        if (res.status == 1) {
          res.data.forEach((obj, index) => {
            var num = (obj.studyingVolume / 10000).toFixed(2);
            if (num >= 999.99) {
              obj.studyingVolume = 999.99;
            } else {
              obj.studyingVolume = num;
            }
          });
          if (this.pageNo == 1) {
            this.searchList = res.data;
            this.pageCount = res.pages;
            if (this.pageCount <= 1) {
              this.loadingText = "没有更多了";
            } else {
              this.loadingText = "加载中...";
            }
          } else {
            this.searchList = this.searchList.concat(res.data);
          }
          if (this.searchList.length == 0) {
            this.isEmpty = true;
          } else {
            this.isEmpty = false;
          }
        }
      });
    },
    getKeyword() {
      this.keyword = this.keyword.replace(/(^\s*)|(\s*$)/g, "");
    },
    searchData() {
      if (this.keyword) {
        this.pageNo = 1;
        this.isResult = true;
        this.isEmpty = false;
        this.getSearchBook();
        for (var i = 0; i < this.historyList.length; i++) {
          if (this.historyList[i] == this.keyword) {
            this.historyList.splice(i, 1);
          }
        }
        this.historyList.unshift(this.keyword);
        this.historyList = this.historyList.slice(0, 10);
        this.$base.setStorage("keyword", JSON.stringify(this.historyList));
        this.$nextTick(() => {
          window.scrollTo(0, 0);
        });
        this.insertPageAccessData();
      }
    },
    closeSearch() {
      this.keyword = "";
      this.isResult = false;
      this.isEmpty = false;
      this.searchList = [];
    },
    chooseData(item) {
      this.keyword = item;
      this.isResult = false;
      this.isEmpty = false;
      this.searchData();
    },
    deleteHistory() {
      MessageBox.confirm("确定要删除全部历史记录？").then((action) => {
        console.log(action);
        if (action == "confirm") {
          this.historyList = [];
          this.$base.removeStorage("keyword");
        }
      });
    },
    routeDetail(item) {
      this.$router.push({
        path:
          "/pages/bookDetail/index?bookId=" + item.id + "&pageType=bookSearch",
      });
    },
  },
};
</script>

<style scoped>
.container {
  /* height:calc(48px + env(safe-area-inset-bottom)); */
  padding-bottom: constant(safe-area-inset-bottom);
  /* 兼容 iOS < 11.2 */
  padding-bottom: env(safe-area-inset-bottom);
  /* 兼容 iOS >= 11.2 */
  /* box-sizing: content-box; */
}
.search-title {
  display: flex;
  padding: 6px 16px;
  border-bottom: 1px solid #f3f3f3;
  justify-content: space-between;
  position: fixed;
  left: 0;
  box-sizing: border-box;
  width: 100%;
  background-color: #ffffff;
  z-index: 99;
}
.search-title {
  top: calc(44px + env(safe-area-inset-top));
}
.content-search {
  padding-top: calc(94px + env(safe-area-inset-top));
}
.search-title > div {
  background-color: #f3f3f3;
  border-radius: 4px;
  display: flex;
  padding: 7px 12px;
  width: 73%;
  justify-content: space-between;
}

.search-title > div > div {
  display: flex;
  width: 80%;
}

.search-title > div > div > img {
  width: 16px;
  height: 16px;
  display: block;
  margin-right: 8px;
  margin-top: 3px;
}
.search-title > div img.close-image {
  width: 16.5px;
  height: 16.5px;
  margin-top: 3px;
}
.search-title > div input {
  font-size: 14px;
  color: #333333;
  width: 100%;
  background-color: #f3f3f3;
  border: none;
}
.search-title span {
  color: #aaaaaa;
  background-color: #f3f3f3;
  border-radius: 4px;
  font-size: 14px;
  padding: 5px 11px;
  line-height: 27px;
}
.search-title span.active {
  background-color: #de3b34;
  color: #ffffff;
}
.search-hot {
  padding: 20px 16px;
  border-bottom: 1px solid #f3f3f3;
}
.search-hot > span {
  font-size: 16px;
  color: #333333;
  font-weight: bold;
}
.hot-list {
  overflow: hidden;
}

.hot-listitem {
  position: relative;
  /* float: left; */
  /* width: 50%; */
  /* display: flex;
  margin-top: 20px; */
}
.hot-num {
  position: absolute;
  left: 0px;
  top: 0px;
  display: block;
  width: 20px;
  height: 20px;
  color: #ffffff;
  font-size: 12px;
  background-color: #bdbdbd;
  border-radius: 4px;
  text-align: center;
  margin-right: 12px;
  line-height: 20px;
}

.hot-name {
  font-size: 14px;
  color: #333333;
  overflow: hidden;
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  line-height: 20px;
}

.hot-listitem:nth-child(1) .hot-num {
  background-color: #ff5555;
}

.hot-listitem:nth-child(2) .hot-num {
  background-color: #ff8700;
}

.hot-listitem:nth-child(3) .hot-num {
  background-color: #ffca55;
}

.history-title {
  display: flex;
  justify-content: space-between;
  padding: 20px 16px;
  margin-top: 4px;
}

.history-title > span:nth-child(1) {
  font-size: 16px;
  color: #333333;
  font-weight: bold;
}

.history-title > span:nth-child(2) {
  font-size: 14px;
  color: #666666;
}

.history-list {
  overflow: hidden;
  text-align: justify;
  padding: 0px 16px;
  display: flex;
  flex-flow: wrap;
  /* justify-content: flex-start; */
}
.history-list > p {
  /* float: left; */
  width: 25%;
  margin-bottom: 20px;
}
.history-list > p > span {
  /* float: left; */
  background: #f3f3f3;
  border-radius: 8px;
  font-size: 12px;
  color: #aaaaaa;
  text-align: center;
  width: 64px;
  padding: 2px 8px;
  overflow: hidden;
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  box-sizing: border-box;
}
.search-list {
  padding: 0px 16px;
}

.no-result {
  text-align: center;
  border-bottom: 1px solid #f3f3f3;
  padding: 51px 0px;
}

.no-result > img {
  width: 88px;
  height: 88px;
  display: block;
  margin: 0 auto;
  margin-bottom: 12px;
}

.no-result > span {
  font-size: 14px;
  color: #666666;
}

.load-more {
  text-align: center;
  font-size: 12px;
  color: #aaaaaa;
  padding: 16px 0px;
}
</style>



// WEBPACK FOOTER //
// src/view/bookSearch/index.vue